module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-row', [_c('el-descriptions', {
    attrs: {
      "title": "基本信息",
      "column": 2
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.op === 'edit'),
      expression: "op === 'edit'"
    }],
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handle_cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.handle_op
    }
  }, [_vm._v(_vm._s(_vm.op === 'show' ? '编辑' : '保存'))])], 1), _vm._v(" "), (_vm.op === 'show') ? _c('el-descriptions-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_vm._v(_vm._s(_vm.data.username))]) : _vm._e(), _vm._v(" "), (_vm.op === 'show') ? _c('el-descriptions-item', {
    attrs: {
      "label": "昵称"
    }
  }, [_vm._v(_vm._s(_vm.data.nick))]) : _vm._e(), _vm._v(" "), (_vm.op === 'show') ? _c('el-descriptions-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_vm._v(_vm._s(_vm.data.email))]) : _vm._e(), _vm._v(" "), (_vm.op === 'show') ? _c('el-descriptions-item', {
    attrs: {
      "label": "电话"
    }
  }, [_vm._v(_vm._s(_vm.data.tel))]) : _vm._e(), _vm._v(" "), (_vm.op === 'show') ? _c('el-descriptions-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-tag', {
    attrs: {
      "size": "small",
      "type": _vm.data.work_statu == '1' ? '' : 'warning'
    }
  }, [_vm._v(_vm._s(_vm.data.work_statu_text ? _vm.data.work_statu_text : '未知'))])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.op === 'edit'),
      expression: "op === 'edit'"
    }]
  }, [_c('el-form', {
    ref: "form_ref",
    attrs: {
      "size": "mini",
      "model": _vm.form,
      "rules": _vm.form_rules,
      "label-position": "right",
      "label-width": "60px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名:",
      "label-width": "70px",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱:",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码:",
      "prop": "userpwd"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini",
      "maxlength": "16",
      "show-password": ""
    },
    model: {
      value: (_vm.form.userpwd),
      callback: function($$v) {
        _vm.$set(_vm.form, "userpwd", $$v)
      },
      expression: "form.userpwd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "昵称:",
      "prop": "nick"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.form.nick),
      callback: function($$v) {
        _vm.$set(_vm.form, "nick", $$v)
      },
      expression: "form.nick"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话:",
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini"
    },
    model: {
      value: (_vm.form.tel),
      callback: function($$v) {
        _vm.$set(_vm.form, "tel", $$v)
      },
      expression: "form.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复密码:",
      "prop": "userpwd2",
      "maxlength": "10",
      "label-width": "85px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "size": "mini",
      "maxlength": "16",
      "show-password": ""
    },
    model: {
      value: (_vm.form.userpwd2),
      callback: function($$v) {
        _vm.$set(_vm.form, "userpwd2", $$v)
      },
      expression: "form.userpwd2"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-row', [_c('el-descriptions', {
    attrs: {
      "title": "其他",
      "column": 1
    }
  }, [_c('el-descriptions-item', {
    attrs: {
      "label": "用户组",
      "contentStyle": _vm.content_style
    }
  }, _vm._l((_vm.info_show('user_group_names')), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "info-item",
      attrs: {
        "size": "small"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "用户角色",
      "contentStyle": _vm.content_style
    }
  }, _vm._l((_vm.info_show('user_role_des')), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "info-item",
      attrs: {
        "size": "small"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "最近登录时间"
    }
  }, [_vm._v(_vm._s(_vm.data.last_login_time))]), _vm._v(" "), _c('el-descriptions-item', {
    attrs: {
      "label": "LDAP"
    }
  }, [_c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.comments),
      expression: "data.comments"
    }],
    attrs: {
      "title": _vm.data.comments,
      "type": "info",
      "closable": false
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-f8f8f28e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/user-info-panel/user-info-panel.vue
// module id = 6238
// module chunks = 81